export default __webpack_public_path__ + "09df7093466f28bcb2b4e65234160ccd.svg";